import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { FeatureContextProvider } from "@/components/Product/Feature/KeyFeatures/components/feature/context/feature.context";
import { useKeyFeaturesContext } from "@/components/Product/Feature/KeyFeatures/context/keyFeatures.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { keyFeatures } = useKeyFeaturesContext();
    const { index } = useMapped();

    const keyFeature = keyFeatures[index];

    return (
        <FeatureContextProvider feature={keyFeature}>
            <li className={cn(className)}>{children}</li>
        </FeatureContextProvider>
    );
};
